import { SuperAppService } from "../../../service/super-app-service";

const fetchAdsDetails = (requestObj) => () => {
    return new Promise((resolve, reject) => {
        SuperAppService.fetchAdsDetails({...requestObj})
            .then(response => {
                resolve(response.data.data);
            })
            .catch(error => {
                reject(error);
            });
    });
};

export {
    fetchAdsDetails
};
